export default "__VITE_ASSET__009d4df7__"